import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import toastr from "toastr";
import { useDispatch } from "react-redux";
import { postToggleItemSale } from "store/actions";
import { Link } from "react-router-dom";
import { Spinner } from "react-bootstrap";

const PubModal = ({ item }) => {
  const dispatch = useDispatch();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [show, setShow] = useState(false);
  const [internalLoading, setinternalLoading] = useState(false);

  const onToggleSale = () => {
    dispatch(
      postToggleItemSale(
        {
          itemId: item?._id,
          type: item?.blockchain || "ethereum",
        },
        (response) => toastr.success(response?.message)
      )
    );
  };

  return (
    <div className="style">
      <img
        onClick={handleShow}
        src="https://img.icons8.com/material-rounded/24/000000/dots-loading--v3.png"
      />

      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="md"
        className="publish-modal"
      >
        <div className="Publish">
          {item?.status === "created" ? (
            <div>
              <h6 className="ml-5">
                <Link className="pubmodal_link" to={`/item/${item?._id}`}>
                  <div className="commonflex">
                    <svg width="20" height="20" viewBox="0 0 32 32">
                      <path
                        fill="currentColor"
                        d="M27.71 4.29a1 1 0 0 0-1.05-.23l-22 8a1 1 0 0 0 0 1.87l9.6 3.84l3.84 9.6a1 1 0 0 0 .9.63a1 1 0 0 0 .92-.66l8-22a1 1 0 0 0-.21-1.05ZM19 24.2l-2.79-7L21 12.41L19.59 11l-4.83 4.83L7.8 13l17.53-6.33Z"
                      />
                    </svg>
                    Publish Item
                    {internalLoading && (
                      <Spinner
                        variant="warning"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      ></Spinner>
                    )}
                  </div>
                </Link>
              </h6>

              <div className="mt-2">
                <Link to={`/create?id=${item?._id}`} className="edit-item">
                  <h6 className="ml-5">
                    <div className="commonflex">
                      <svg width="20" height="20" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M5 23.7q-.825 0-1.413-.588Q3 22.525 3 21.7v-14q0-.825.587-1.413Q4.175 5.7 5 5.7h8.925l-2 2H5v14h14v-6.95l2-2v8.95q0 .825-.587 1.412q-.588.588-1.413.588Zm7-9Zm4.175-8.425l1.425 1.4l-6.6 6.6V15.7h1.4l6.625-6.625l1.425 1.4l-7.2 7.225H9v-4.25Zm4.275 4.2l-4.275-4.2l2.5-2.5q.6-.6 1.438-.6q.837 0 1.412.6l1.4 1.425q.575.575.575 1.4T22.925 8Z"
                        />
                      </svg>
                      Edit item
                    </div>
                  </h6>
                </Link>
              </div>
            </div>
          ) : null}

          {item?.status == "created" ? null : (
            <div className="mt-2">
              <h6 className="ml-5">
                {item?.status == "active" ? (
                  <div onClick={onToggleSale} className="commonflex">
                    <svg width="20" height="20" viewBox="0 0 28 28">
                      <path
                        fill="currentColor"
                        d="M11.5 6h5a2.5 2.5 0 0 0-5 0ZM10 6a4 4 0 0 1 8 0h6.25a.75.75 0 0 1 0 1.5h-1.31l-1.217 14.603A4.25 4.25 0 0 1 17.488 26h-6.976a4.25 4.25 0 0 1-4.235-3.897L5.06 7.5H3.75a.75.75 0 0 1 0-1.5H10ZM7.772 21.978a2.75 2.75 0 0 0 2.74 2.522h6.976a2.75 2.75 0 0 0 2.74-2.522L21.436 7.5H6.565l1.207 14.478ZM11.75 11a.75.75 0 0 1 .75.75v8.5a.75.75 0 0 1-1.5 0v-8.5a.75.75 0 0 1 .75-.75Zm5.25.75a.75.75 0 0 0-1.5 0v8.5a.75.75 0 0 0 1.5 0v-8.5Z"
                      />
                    </svg>
                    Remove from sell
                  </div>
                ) : (
                  <Link className="pubmodal_link" to={`/sell/${item?._id}`}>
                    <div className="commonflex">
                      <svg width="20" height="20" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M12.85 22q-.425 0-.8-.163q-.375-.162-.65-.437l-8.8-8.8q-.275-.275-.437-.65Q2 11.575 2 11.15V4q0-.825.588-1.413Q3.175 2 4 2h7.15q.425 0 .8.162q.375.163.65.438l8.8 8.825q.575.575.575 1.412q0 .838-.575 1.413l-7.15 7.15q-.275.275-.637.437q-.363.163-.763.163Zm-.025-2l7.15-7.15L11.15 4H4v7.15ZM6.5 8q.625 0 1.062-.438Q8 7.125 8 6.5t-.438-1.062Q7.125 5 6.5 5t-1.062.438Q5 5.875 5 6.5t.438 1.062Q5.875 8 6.5 8ZM4 4Z"
                        />
                      </svg>
                      Put on Sell
                    </div>
                  </Link>
                )}
              </h6>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default PubModal;
